/**
 * Web Component: collection-promo-banner
 * Banner promocional que se inyecta en el grid de productos Klevu.
 * Atributos: image, image-mobile (opcional), url, banner-ref
 */
(function () {
  const tag = 'collection-promo-banner';

  if (customElements.get(tag)) return;

  class CollectionPromoBanner extends HTMLElement {
    static get observedAttributes() {
      return ['image', 'image-mobile', 'url', 'banner-ref'];
    }

    constructor() {
      super();
      this._image = '';
      this._imageMobile = '';
      this._url = '#';
      this._bannerRef = 'banner';
    }

    connectedCallback() {
      this._render();
      this._attachClickHandler();
    }

    attributeChangedCallback(name, _old, value) {
      if (name === 'image') this._image = value || '';
      if (name === 'image-mobile') this._imageMobile = value || '';
      if (name === 'url') this._url = value || '#';
      if (name === 'banner-ref') this._bannerRef = value || 'banner';
      if (this.isConnected) {
        this._render();
        this._attachClickHandler();
      }
    }

    _createImg(src, className) {
      const img = document.createElement('img');
      img.src = src || '';
      img.alt = '';
      img.loading = 'lazy';
      img.className = className;
      img.onerror = () => {
        const li = this.closest('li.klevuBanner');
        if (li) li.style.display = 'none';
      };
      return img;
    }

    _render() {
      const imgDesktop = this._image;
      const imgMobile = this._imageMobile;
      const hasAnyImage = imgDesktop || imgMobile;

      if (!hasAnyImage) {
        this.innerHTML = '';
        const li = this.closest('li.klevuBanner');
        if (li) li.style.display = 'none';
        return;
      }

      const wrap = document.createElement('div');
      wrap.className = 'kuProdWrap kuBannerWrap';

      const imgWrap = document.createElement('div');
      imgWrap.className = 'kuBannerImgWrap';

      const a = document.createElement('a');
      a.href = this._url;
      a.className = 'klevuBannerClick';
      a.setAttribute('data-name', this._bannerRef);
      a.target = '_self';
      a.setAttribute('aria-label', 'Banner promocional');

      if (imgDesktop && imgMobile && imgDesktop !== imgMobile) {
        const imgD = this._createImg(imgDesktop, 'kuBannerImgDesktop');
        const imgM = this._createImg(imgMobile, 'kuBannerImgMobile');
        a.appendChild(imgD);
        a.appendChild(imgM);
      } else if (imgDesktop) {
        const img = this._createImg(imgDesktop, '');
        a.appendChild(img);
      } else if (imgMobile) {
        const img = this._createImg(imgMobile, 'kuBannerImgMobile');
        a.appendChild(img);
      }

      imgWrap.appendChild(a);
      wrap.appendChild(imgWrap);

      this.innerHTML = '';
      this.appendChild(wrap);
    }

    _attachClickHandler() {
      const link = this.querySelector('.klevuBannerClick');
      if (!link || link.dataset.attached === 'true') return;

      link.dataset.attached = 'true';
      link.addEventListener('click', (e) => {
        const ref = link.getAttribute('data-name') || 'banner';
        const trackingUrl =
          'https://stats.ksearchnet.com/analytics/datatracking?type=banner&klevu_bannerid=' +
          encodeURIComponent(ref) +
          '&klevu_term=*&klevu_request=click';
        new Image().src = trackingUrl;
      });
    }
  }

  customElements.define(tag, CollectionPromoBanner);
})();